// Mock data for zeilian clone

export const categories = [
  { id: 1, name: 'Vehicles', icon: 'Car', count: 0, slug: 'vehicles' },
  { id: 2, name: 'Mobiles', icon: 'Smartphone', count: 0, slug: 'mobiles' },
  { id: 3, name: 'Property', icon: 'Home', count: 0, slug: 'property' },
  { id: 4, name: 'Electronics', icon: 'Laptop', count: 0, slug: 'electronics' },
  { id: 5, name: 'Home & Garden', icon: 'Sofa', count: 0, slug: 'home-garden' },
  { id: 6, name: 'Services', icon: 'Wrench', count: 0, slug: 'services' },
  { id: 7, name: 'Business & Industry', icon: 'Briefcase', count: 0, slug: 'business-industry' },
  { id: 8, name: 'Jobs', icon: 'Users', count: 0, slug: 'jobs' },
  { id: 9, name: 'Animals', icon: 'Dog', count: 0, slug: 'animals' },
  { id: 10, name: 'Hobby Sport & Kids', icon: 'Trophy', count: 0, slug: 'hobby-sport-kids' },
  { id: 11, name: 'Fashion & Beauty', icon: 'Shirt', count: 0, slug: 'fashion-beauty' },
  { id: 12, name: 'Education', icon: 'BookOpen', count: 0, slug: 'education' },
  { id: 13, name: 'Essentials', icon: 'Package', count: 0, slug: 'essentials' },
  { id: 14, name: 'Agriculture', icon: 'Leaf', count: 0, slug: 'agriculture' },
  { id: 15, name: 'Work Overseas', icon: 'Plane', count: 0, slug: 'work-overseas' },
  { id: 16, name: 'Student Visa', icon: 'GraduationCap', count: 0, slug: 'student-visa' },
  { id: 17, name: 'Other', icon: 'MoreHorizontal', count: 0, slug: 'other' },
];

export const listings = [
  {
    id: 1,
    title: 'iPhone 15 Pro Max 256GB - Like New',
    price: 450000,
    category: 'Electronics',
    location: 'Colombo',
    description: 'iPhone 15 Pro Max in excellent condition. Used for only 2 months. Comes with original box, charger, and warranty.',
    image: 'https://images.unsplash.com/photo-1696446702463-a54c899f17ef?w=400',
    seller: { name: 'John Silva', phone: '+94771234567', memberSince: '2023', rating: 4.8 },
    featured: true,
    promoted: true,
    views: 245,
    postedDate: '2025-07-10',
    condition: 'Like New',
    negotiable: true
  },
  {
    id: 2,
    title: 'Toyota Aqua 2020 - Low Mileage',
    price: 5200000,
    category: 'Vehicles',
    location: 'Kandy',
    description: 'Toyota Aqua 2020 model with only 25,000km mileage. Full option with push start, alloy wheels, and reverse camera.',
    image: 'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=400',
    seller: { name: 'Kasun Perera', phone: '+94772345678', memberSince: '2022', rating: 4.9 },
    featured: true,
    promoted: false,
    views: 892,
    postedDate: '2025-07-09',
    condition: 'Used',
    negotiable: true
  },
  {
    id: 3,
    title: '3 Bedroom House for Sale - Mount Lavinia',
    price: 35000000,
    category: 'Property',
    location: 'Mount Lavinia',
    description: 'Beautiful 3 bedroom house with modern amenities. 2000 sqft, close to beach, schools, and main road.',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400',
    seller: { name: 'Nimal Fernando', phone: '+94773456789', memberSince: '2021', rating: 4.7 },
    featured: false,
    promoted: true,
    views: 567,
    postedDate: '2025-07-08',
    condition: 'New',
    negotiable: false
  },
  {
    id: 4,
    title: 'MacBook Pro M3 14-inch 2024',
    price: 680000,
    category: 'Electronics',
    location: 'Colombo',
    description: 'Brand new MacBook Pro with M3 chip. 16GB RAM, 512GB SSD. Perfect for professionals and creatives.',
    image: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400',
    seller: { name: 'Tech Hub Lanka', phone: '+94774567890', memberSince: '2023', rating: 4.9 },
    featured: true,
    promoted: false,
    views: 421,
    postedDate: '2025-07-11',
    condition: 'Brand New',
    negotiable: false
  },
  {
    id: 5,
    title: 'Software Engineer - React & Node.js',
    price: 150000,
    category: 'Jobs',
    location: 'Colombo',
    description: 'Looking for experienced software engineer with 3+ years experience in React and Node.js. Competitive salary and benefits.',
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400',
    seller: { name: 'Tech Solutions Ltd', phone: '+94775678901', memberSince: '2022', rating: 4.6 },
    featured: false,
    promoted: true,
    views: 234,
    postedDate: '2025-07-11',
    condition: 'N/A',
    negotiable: true
  },
  {
    id: 6,
    title: 'Samsung 55" 4K Smart TV',
    price: 185000,
    category: 'Electronics',
    location: 'Galle',
    description: 'Samsung 55 inch 4K UHD Smart TV. HDR support, built-in streaming apps. 1 year warranty remaining.',
    image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=400',
    seller: { name: 'Saman Electronics', phone: '+94776789012', memberSince: '2023', rating: 4.5 },
    featured: false,
    promoted: false,
    views: 156,
    postedDate: '2025-07-10',
    condition: 'Used',
    negotiable: true
  },
  {
    id: 7,
    title: 'Honda CBR 250R 2022 - Red',
    price: 950000,
    category: 'Vehicles',
    location: 'Negombo',
    description: 'Honda CBR 250R in excellent condition. Low mileage, well maintained. Perfect for sports bike enthusiasts.',
    image: 'https://images.unsplash.com/photo-1558981852-426c6c22a060?w=400',
    seller: { name: 'Bike World', phone: '+94777890123', memberSince: '2021', rating: 4.8 },
    featured: false,
    promoted: false,
    views: 389,
    postedDate: '2025-07-09',
    condition: 'Used',
    negotiable: true
  },
  {
    id: 8,
    title: 'Apartment for Rent - Dehiwala',
    price: 65000,
    category: 'Property',
    location: 'Dehiwala',
    description: '2 bedroom furnished apartment. Modern kitchen, parking, security. Available immediately.',
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400',
    seller: { name: 'Property Dealers', phone: '+94778901234', memberSince: '2022', rating: 4.4 },
    featured: false,
    promoted: false,
    views: 278,
    postedDate: '2025-07-11',
    condition: 'Furnished',
    negotiable: true
  }
];

export const membershipPlans = [
  {
    id: 1,
    name: 'Free',
    price: 0,
    features: [
      'Post up to 3 ads per month',
      'Basic ad visibility',
      'Standard support',
      '7 days ad duration'
    ],
    recommended: false
  },
  {
    id: 2,
    name: 'Basic',
    price: 2500,
    features: [
      'Post up to 15 ads per month',
      'Enhanced visibility',
      'Priority support',
      '30 days ad duration',
      'Ad refresh option'
    ],
    recommended: false
  },
  {
    id: 3,
    name: 'Premium',
    price: 5900,
    features: [
      'Unlimited ad posting',
      'Top placement in search',
      '24/7 Premium support',
      '60 days ad duration',
      'Featured badge',
      'Advanced analytics',
      'Social media promotion'
    ],
    recommended: true
  }
];

export const messages = [
  {
    id: 1,
    listingId: 1,
    listingTitle: 'iPhone 15 Pro Max 256GB',
    sender: 'Buyer',
    message: 'Is this still available?',
    timestamp: '2025-07-11T10:30:00',
    read: true
  },
  {
    id: 2,
    listingId: 1,
    listingTitle: 'iPhone 15 Pro Max 256GB',
    sender: 'You',
    message: 'Yes, it is available. When would you like to check it?',
    timestamp: '2025-07-11T10:35:00',
    read: true
  },
  {
    id: 3,
    listingId: 2,
    listingTitle: 'Toyota Aqua 2020',
    sender: 'Buyer',
    message: 'Can you negotiate on the price?',
    timestamp: '2025-07-11T14:20:00',
    read: false
  }
];

export const userAds = [
  {
    id: 1,
    title: 'iPhone 15 Pro Max 256GB - Like New',
    price: 450000,
    category: 'Electronics',
    status: 'active',
    views: 245,
    messages: 8,
    postedDate: '2025-07-10',
    expiresDate: '2025-08-10'
  },
  {
    id: 9,
    title: 'Gaming PC - RTX 4070',
    price: 350000,
    category: 'Electronics',
    status: 'active',
    views: 89,
    messages: 3,
    postedDate: '2025-07-09',
    expiresDate: '2025-08-09'
  },
  {
    id: 10,
    title: 'Canon EOS R6 Mark II',
    price: 620000,
    category: 'Electronics',
    status: 'expired',
    views: 156,
    messages: 12,
    postedDate: '2025-06-05',
    expiresDate: '2025-07-05'
  }
];

export const locations = [
  'Colombo', 'Kandy', 'Galle', 'Negombo', 'Dehiwala',
  'Mount Lavinia', 'Moratuwa', 'Ratmalana', 'Kotte',
  'Maharagama', 'Panadura', 'Kalutara', 'Jaffna', 'Trincomalee'
];